<script>
  import { onDestroy } from "svelte";
  import { lang } from '../lib/stores';
  import DirtyStats from "./DirtyStats.svelte";
  import DrugsStats from "./DrugsStats.svelte";
  import FamilyStats from "./FamilyStats.svelte";
  import FamilyChart from "./FamilyChart.svelte";
  import LinksToSongs from "./LinksToSongs.svelte";
  import LoveStats from "./LoveStats.svelte";
  import LoveChart from "./LoveChart.svelte";
  export let data = {};

  let selectedLang;
	const unsubscribe = lang.subscribe((value) => selectedLang = value);
  onDestroy(unsubscribe);

  $: data;
</script>

<section class="chapter-2 chapter-inner">
  <div class="p">
    <p>
      {#if selectedLang === 'it'}
        La musica <em>hip hop</em> e la <em>trap</em> in particolare sono spesso
        al
        <a
          href="https://www.lastampa.it/politica/2024/07/02/news/lega_musica_trap_criminalita-14441699/"
          target="_blank">centro di polemiche mediatiche</a
        >
        legate alla loro presunta violenza e misoginia. A differenza di quella di molti
        suoi colleghi, la musica di Ghali e Ghali stesso come personaggio pubblico
        sono invece stati spesso al centro di polemiche politiche furiose (<a
          href="https://www.ilfoglio.it/cronaca/2021/11/09/video/la-lite-tra-ghali-e-salvini-che-poi-finge-di-non-sapere-chi-sia-3347327/"
          target="_blank">qui il suo storico scontro con Salvini</a
        >), dovute essenzialmente alle sue esternazioni sulla
        <a
          href="https://mediterranearescue.org/it/news/un-rapper-puo-far-cambiare-idea-all-italia-sui-migranti"
          target="_blank">situazione dei migranti</a
        >
        e sulla
        <a
          href="https://www.ansa.it/sito/notizie/cultura/musica/2024/10/28/ghali-in-palestina-non-e-guerra-ma-genocidio_67d22f04-add1-425f-b572-f9b28b11ca64.html"
          target="_blank">violenza in Medioriente</a
        >.
        <em
          >Gli album che abbiamo analizzato sono precedenti alla sua svolta
          "politica"</em
        >, ma alcuni temi sono già presenti, anche se in maniera immatura
      {:else}
        <em>Hip hop</em> music and <em>trap</em> in particular are often at the
        <a href="https://www.lastampa.it/politica/2024/07/02/news/lega_musica_trap_criminalita-14441699/" target="_blank">center of media controversies</a> 
        related to their alleged violence and misogyny. Unlike that of many of his colleagues, Ghali's music and Ghali himself as a public figure have often been at the center of furious political controversies ( <a href="https://www.ilfoglio.it/cronaca/2021/11/09/video/la-lite-tra-ghali-e-salvini-che-poi-finge-di-non-sapere-chi-sia-3347327/" target="_blank">here his historic clash with Salvini</a> ), essentially due to his statements on the
        <a href="https://mediterranearescue.org/it/news/un-rapper-puo-far-cambiare-idea-all-italia-sui-migranti" target="_blank">situation of migrants</a> 
        and
        <a href="https://www.ansa.it/sito/notizie/cultura/musica/2024/10/28/ghali-in-palestina-non-e-guerra-ma-genocidio_67d22f04-add1-425f-b572-f9b28b11ca64.html" target="_blank">violence in the Middle East</a> .
        <em>The albums we have analyzed are prior to his "political" turn</em> , but some themes are already present, even if in an immature way.
      {/if}
    </p>
    <blockquote>
      <p>
        Tua madre piange, sei un coglione, non un criminale<br />
        <em>Sto con chi è nato in strada e non ci vuole stare</em>
      </p>
      <p><small>Optional, Lunga Vita a Sto, 2017</small></p>
    </blockquote>
    <p>
      {#if selectedLang === 'it'}
        C'è però un tema particolare, legato alla sua storia personale: il
        rapporto con i suoi genitori e <a
          href="https://www.elle.com/it/showbiz/celebrities/a62575956/ghali-mamma-malattia-testo-niente-panico/"
          target="_blank">specialmente con la madre</a
        >, alla quale Ghali ha dedicato spesso parole d'affetto (cosa a quanto
        pare abbastanza inusuale da indurre i media italiani a
        <a
          href="https://www.marieclaire.it/attualita/gossip/a46687665/mamma-di-ghali/"
          target="_blank">dedicarle interi articoli</a
        >).
      {:else}
        There is, however, a particular theme, linked to his personal history: the relationship with his parents and <a href="https://www.elle.com/it/showbiz/celebrities/a62575956/ghali-mamma-malattia-testo-niente-panico/" target="_blank">especially with his mother</a> , to whom Ghali has often dedicated words of affection (something apparently unusual enough to induce the Italian media to
        <a href="https://www.marieclaire.it/attualita/gossip/a46687665/mamma-di-ghali/" target="_blank">dedicate entire articles to her</a> ).
      {/if}
    </p>
    <p>
      {#if selectedLang === 'it'}
        In questa sezione abbiamo provato a raccogliere le parole per temi, per
        vedere quanto ciascuno di questi temi pesi sulla sua produzione.
      {:else}
        In this section we have tried to collect words by themes, to see how much each of these themes weighs on his production.
      {/if}
    </p>
  </div>
  <div class="subtitle">
    <h3>
      {#if selectedLang === 'it'}
        Droghe e porconi
      {:else}
        Drugs and filth
      {/if}
    </h3>
    <h2>
      {#if selectedLang === 'it'}
        Se vieni dai quartieri non puoi ignorarli
      {:else}
        If you come from the 'hoods you can't ignore them
      {/if}
    </h2>
  </div>
  <div class="chart">
    <DirtyStats
      data={data?.chapter2?.dirtyStats ?? {}}
      totalWords={data?.stats.totalWords ?? 0}
      totalText={data?.stats.totalTextLength ?? 0}
    />
  </div>
  <div class="chart">
    <LinksToSongs data={data?.chapter2?.dirtyToSongs ?? []} show="both" />
  </div>
  <div class="chart">
    <DrugsStats
      data={data?.chapter2?.drugsStats ?? {}}
      totalWords={data?.stats.totalWords ?? 0}
      totalText={data?.stats.totalTextLength ?? 0}
    />
  </div>
  <div class="chart">
    <LinksToSongs data={data?.chapter2?.drugsToSongs ?? []} show="both" />
  </div>
  <div class="subtitle">
    <h3>
      {#if selectedLang === 'it'}
        La famiglia
      {:else}
        The family
      {/if}
    </h3>
    <h2>
      {#if selectedLang === 'it'}
        Di mamma ce n'è una sola
      {:else}
        There is only one mother
      {/if}
    </h2>
  </div>
  <div class="chart">
    <FamilyStats />
  </div>
  <div class="chart">
    <FamilyChart data={data?.chapter2?.familyStats ?? {}} />
  </div>
  <div class="subtitle">
    <h3>
      {#if selectedLang === 'it'}
        Che cos'è l'amor
      {:else}
        What is love?
      {/if}
    </h3>
    <h2>
      {#if selectedLang === 'it'}
        In ogni album rap deve esserci una canzone d'amore
      {:else}
        In every rap album there must be a love song
      {/if}
    </h2>
  </div>
  <div class="chart">
    <LoveStats data={data?.chapter2?.loveStats} />
  </div>
  <div class="chart">
    <LoveChart {data} />
  </div>
</section>

<style>
</style>
